/** Supported API / UI language codes (ISO 639-1). */
export const SUPPORTED_LANG_CODES = ["en", "hi", "ar"];

const LEGACY_CODE_MAP = {
  eng: "en",
  english: "en",
  hin: "hi",
  hindi: "hi",
  arb: "ar",
  arabic: "ar",
};

/**
 * Normalize any stored/UI language value to en|hi|ar.
 * Handles legacy Eng/Hin/Arb and locale tags like en-US.
 */
export function normalizeLangCode(raw) {
  if (raw == null || raw === "") return "en";
  let code = String(raw).trim();
  const sep = code.search(/[-_,]/);
  if (sep > 0) code = code.slice(0, sep);
  code = code.toLowerCase();
  if (LEGACY_CODE_MAP[code]) return LEGACY_CODE_MAP[code];
  if (SUPPORTED_LANG_CODES.includes(code)) return code;
  return "en";
}

/** Read and normalize language from localStorage `Lang`. */
export function getStoredLangCode() {
  try {
    return normalizeLangCode(localStorage.getItem("Lang"));
  } catch {
    return "en";
  }
}

/**
 * API langKey convention used by WLJ TranslateAsync:
 * English → "" (skip translation); otherwise lowercase hi|ar.
 */
export function getLangKey(raw) {
  const code = raw == null ? getStoredLangCode() : normalizeLangCode(raw);
  return code === "en" ? "" : code;
}

/** Apply html lang + dir so RTL (e.g. Arabic) survives full page reloads. */
export function applyDocumentLangDir(raw) {
  const code = normalizeLangCode(raw);
  if (typeof document === "undefined") return code;
  const root = document.documentElement;
  root.lang = code;
  root.dir = code === "ar" ? "rtl" : "ltr";
  if (document.body) {
    document.body.dir = root.dir;
  }
  return code;
}

/** Persist normalized language code and sync document direction. */
export function setStoredLangCode(raw) {
  const code = normalizeLangCode(raw);
  try {
    localStorage.setItem("Lang", code);
  } catch {
    // ignore quota / private mode
  }
  applyDocumentLangDir(code);
  return code;
}
